/** Canonical analytics event names — keep aligned with GTM triggers. */
export const AnalyticsEvents = Object.freeze({
  PAGE_VIEW: 'page_view',
  VIEW_FEATURES: 'view_features',
  VIEW_PRICING: 'view_pricing',
  VIEW_DEMO: 'view_demo',
  CLICK_CONTACT: 'click_contact',
  CLICK_WHATSAPP: 'click_whatsapp',
  CLICK_DEMO: 'click_demo',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  EMAIL_VERIFIED: 'email_verified',
  START_TRIAL: 'start_trial',
  INDUSTRY_SELECTED: 'industry_selected',
  PLAN_SELECTED: 'plan_selected',
  SELECT_PLAN: 'select_plan',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  GENERATE_LEAD: 'generate_lead',
  DEMO_REQUEST: 'demo_request',
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  CALLBACK_REQUEST: 'callback_request',
  LOGIN: 'login',
  AGENCY_CREATED: 'agency_created',
});

/** @typedef {'realestate'|'immigration'|'education'} AnalyticsIndustry */

export const ANALYTICS_INDUSTRIES = Object.freeze({
  REAL_ESTATE: 'realestate',
  IMMIGRATION: 'immigration',
  EDUCATION: 'education',
});

export const ANALYTICS_PLANS = Object.freeze({
  STARTER: 'starter',
  GROWTH: 'growth',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise',
});
